import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FileDisplayComponent } from '../../file-display.component';

@Component({
    selector: '[app-file-display-with-dropdown]',
    templateUrl: './file-display-with-dropdown.component.html',
    styleUrls: [
        './../../file-display.component.scss',
        './file-display-with-dropdown.component.scss'
    ],
    standalone: false
})
export class FileDisplayWithDropdownComponent extends FileDisplayComponent {

  @Input() dropdownControl: AbstractControl;
  @Input() disabledUploadDueToDropdownLogic: boolean;
  @Input() customDropdownSelection: {
    attributeName: string;
    attributeHeader: string;
    values: { label: string; value: string; }[];
    disableRemoveButtonOnSuccess?: boolean;
  }

  dropdownChangesSubscription: Subscription;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit(); // is this line necessary? or will it run th eonInit twice?

    if (this.customDropdownSelection && this.dropdownControl) {
      this.dropdownControl.patchValue(this.displayableFileObj?.documentDescription);
      /** Trigger component's validation logic on dropdown changes */
      this.dropdownChangesSubscription = this.dropdownControl.valueChanges.subscribe( nada => this.ngOnChanges(null) );
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.dropdownChangesSubscription) {
      this.dropdownChangesSubscription.unsubscribe();
    }
  }
  
  /** Used for ternary operation to (1) determine if it exists and (2) determines validity */
  customValidForUploadLogic(): { exists: boolean; value: boolean } {
    return { exists: true, value: this.dropdownControl.status === "VALID" };
  }
  
  preUploadSingleFileBehavior() {
    // Validate Custom Dropdown
    if (this.customDropdownSelection) {
      if (!this.dropdownControl?.valid) {
        this.dropdownControl.markAsTouched();
        this.dropdownControl.updateValueAndValidity();
        return;
      } else {
        this.displayableFileObj.documentDescription = this.dropdownControl.value;
        this.dropdownControl.disable();
      }
    }
  }

}
